import jQuery from 'jquery';
import { getCSRFToken } from '@shared/cookie';
import 'jquery-validate';

export default {
  $form: jQuery('#login-form'),
  init() {
    this.form_validate();
  },
  form_validate() {
    const self = this;

    this.$form.validate({
      rules: {
        username: {
          required: true,
        },
        passwd: {
          required: true,
        },
      },
      highlight(element) {
        jQuery(element)
          .closest('.control-group')
          .removeClass('success is-valid')
          .addClass('error is-invalid');
      },
      unhighlight(element) {
        jQuery(element).closest('.control-group')
          .removeClass('error is-invalid');
      },
      errorPlacement(error, element) {
        element.parents('.control-group')
          .addClass('error is-invalid')
          .removeClass('success is-valid')
          .find('.help-inline')
          .append(error);
      },
      submitHandler(form) {
        jQuery('#login-error').slideUp();
        jQuery('#login-alert').slideUp();
        jQuery('#login-bt-forgot-pwd').hide();
        jQuery('#login-ajax-spinner-div').show();

        if (location.protocol === 'https:') {
          self.verify_user();
          return false;
        }
        form.submit();
      },
    });
  },
  verify_user() {
    const $username = this.$form.find('[name="username"]').val();
    const $password = this.$form.find('[name="passwd"]').val();
    const $savelogin = this.$form.find('[name="savelogin"]').val();

    if ($username === '' || $password === '') {
      return false;
    }

    jQuery.ajax({
      type: 'post',
      data: {
        username: $username,
        passwd: $password,
        savelogin: $savelogin,
        fromHomePage: true,
        csrf_token: getCSRFToken(),
      },
      dataType: 'json',
      url: '/ajax/login.php',
      success(response) {
        if (response.status === 'success') {
          if (response.redirect) {
            window.location = response.redirect;
            return;
          }
          jQuery('#login-success').slideDown();
          setTimeout(() => {
            window.location = '/dashboard/';
          }, 1500);
        } else {
          jQuery('#login-ajax-spinner-div').hide();
          jQuery('#login-bt-forgot-pwd').show();
          if (response.code === 5) {
            jQuery('#login-alert').text(response.msg).slideDown();
          } else if (response.code === 2) { // for closed accounts
            jQuery('#login-error').text(response.msg).slideDown();
          } else {
            jQuery('#login-error').slideDown();
          }
        }
      },
    });
    return false;
  },
};
